<template>
  <v-text-field
    :value="value"
    @input="$emit('input', $event)"
    v-bind="$attrs"
    type="number"
    :hint="hint"
  >
    <template #append>
      <v-menu
        v-model="popupInputMenu"
        :close-on-content-click="false"
      >
        <template #activator="{on}">
          <v-btn
            icon
            color="primary"
            v-on="on"
          >
            <v-icon>
              mdi-calculator
            </v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-title>
            Apply Formatted Duration
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="popupInputValue"
              label="Duration"
              type="number"
              min="0"
              hide-details
            />
            <v-select
              v-model="popupInputDuration"
              :items="DURATION_OPTIONS"
              label="Unit"
              hide-details
            />
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn
              color="error"
              @click="popupInputMenu = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="onPopupInputConfirm"
            >
              Apply
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    value: {
      type: Number,
      defautValue: 0,
    }
  },
  data() {
    return {
      DURATION_OPTIONS: ['seconds', 'minutes', 'hours', 'days'],
      popupInputValue: null,
      popupInputDuration: 'seconds',
      popupInputMenu: false,
    }
  },

  computed: {
    hint() {
      if (!this.value) {
        return ''
      }
      const duration = moment.duration(this.value, 'seconds')

      return `${Math.floor(duration.asHours())} hrs ${duration.minutes()} min ${duration.seconds()} sec`
    },
  },

  methods: {
    onPopupInputConfirm() {
      const duration = moment.duration(this.popupInputValue, this.popupInputDuration).asSeconds()

      this.$emit('input', duration)
      this.popupInputMenu = false
    },
  },

  watch: {
    popupInputMenu(isOpen) {
      if (!isOpen) {
        this.popupInputValue = null
        this.popupInputDuration = this.DURATION_OPTIONS[0]
      }
    },
  }
}
</script>
